import React, { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { CatalogueMainHeader, ConfirmDeleteModal, CatalogueHeader, ProjectsList } from '../../components/catalogue';
import { useProjects } from '../../hooks/useProjects';
import { CatalogueToolsProps } from '../../types/project';

export const CatalogueTools: React.FC<CatalogueToolsProps> = ({ username }) => {
    const { isAuthenticated, isLoading: authLoading } = useAuth0();
    const navigate = useNavigate();
    const { projects, isLoading, error, loadProjects, deleteProject } = useProjects();
    const [confirmDelete, setConfirmDelete] = useState<{ id: string; name: string } | null>(null);

    useEffect(() => {
        if (!isAuthenticated && !authLoading) {
            navigate('/');
            return;
        }

        if (isAuthenticated) {
            loadProjects();
        }
    }, [isAuthenticated, authLoading, loadProjects, navigate]);

    const handleDeleteProject = async (projectId: string) => {
        const success = await deleteProject(projectId);
        if (success) {
            setConfirmDelete(null);
        }
    };

    const handleCreateDerivative = () => {
        navigate('/derivative');
    };

    const handleContinueProject = (projectId: string) => {
        navigate(`/catalogue/${projectId}`);
    };

    const handleDeleteClick = (projectId: string, projectName: string) => {
        setConfirmDelete({ id: projectId, name: projectName });
    };

    return (
        <div className="min-h-screen bg-background">
            <CatalogueMainHeader username={ username } />

            <CatalogueHeader
                onCreateDerivative={ handleCreateDerivative }
            />

            <div className="mt-10 mx-16 overflow-y-auto pr-2 max-h-[calc(100vh-220px)]">
                <ProjectsList
                    projects={ projects }
                    isLoading={ isLoading }
                    error={ error }
                    onDeleteProject={ handleDeleteClick }
                    onContinueProject={ handleContinueProject }
                />
            </div>

            { confirmDelete && (
                <ConfirmDeleteModal
                    projectName={ confirmDelete.name }
                    onCancel={ () => setConfirmDelete(null) }
                    onConfirm={ () => handleDeleteProject(confirmDelete.id) }
                />
            ) }
        </div>
    );
}; 